import { LAYOUTS, } from '@voltmoney/types';
import { FontSizeTokens, IconSizeTokens, IconTokens, StackAlignItems, StackHeight, StackJustifyContent, StackType, StackWidth, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import SharedPropsService, { BUILD_TYPE } from "../../SharedPropsService";
export const template = async () => {
    return {
        layout: {
            id: ROUTE.KYC_URL_REDIRECT,
            type: LAYOUTS.LIST,
            widgets: [
                {
                    id: "containerStack", type: WIDGET.STACK
                }
            ],
        },
        datastore: {
            containerStack: {
                type: StackType.column,
                width: StackWidth.FULL,
                height: StackHeight.FULL,
                justifyContent: StackJustifyContent.center,
                alignItems: StackAlignItems.center,
                widgetItems: [
                    { id: "loaderIcon", type: WIDGET.ICON },
                    { id: "loaderText", type: WIDGET.TEXT },
                ]
            },
            loaderIcon: {
                name: IconTokens.Pending,
                size: IconSizeTokens.XXXXXXXXL,
            },
            loaderText: {
                label: 'Loading... Please wait',
                fontSize: FontSizeTokens.LG,
            }
        },
    };
};
const getBuildType = (buildType) => {
    switch (buildType) {
        case BUILD_TYPE.BORROWER_STAGING: {
            return "https://app.staging.voltmoney.in";
        }
        case BUILD_TYPE.BORROWER_TEST_STAGING: {
            return "https://test.staging.voltmoney.in";
        }
        case BUILD_TYPE.BORROWER_QA_STAGING: {
            return "https://qa.staging.voltmoney.in";
        }
        case BUILD_TYPE.BORROWER_LOS_STAGING: {
            return "https://los.staging.voltmoney.in";
        }
        case BUILD_TYPE.BORROWER_PRODUCTION: {
            return "https://app.voltmoney.in";
        }
        case BUILD_TYPE.BORROWER_LMS_STAGING: {
            return "https://lms.staging.voltmoney.in";
        }
    }
};
export const kycUrlRedirectMF = {
    onLoad: async ({ network }) => {
        const message = "refreshDone";
        let origin = await SharedPropsService.getBuildType();
        let allowedOrigin = getBuildType(origin);
        window?.parent?.postMessage(message, allowedOrigin);
        if (window?.opener) {
            console.warn("TRIED TO SEND THE MESSAGE");
            window?.opener?.postMessage(message, allowedOrigin);
        }
        else {
            console.error("No opener window found.");
        }
        return Promise.resolve(template());
    },
    clearPrevious: true,
};
